import type { Documento } from './tipos';

// Termos de uso do Se Liga Católico (texto exato, só tela).
export const termos: Documento = {
  titulo: 'Termos de uso do Se Liga Católico',
  atualizado: 'Atualizados em 29/09/2026.',
  secoes: [
    {
      id: 'o-que-e',
      titulo: '1. O que é o Se Liga Católico',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Uma plataforma que ajuda paróquias, movimentos, pastorais e grupos a divulgar e organizar eventos: inscrições, ingressos, fichas de barraca, ações entre amigos, equipes e presença. Responsável: André Trindade.',
        },
      ],
    },
    {
      id: 'quem-organiza',
      titulo: '2. Quem organiza o evento',
      blocos: [
        {
          tipo: 'p',
          texto:
            'O Se Liga Católico **não é o organizador dos eventos**. Cada evento é de responsabilidade de quem o publicou: data, local, programação, valores, vagas, cancelamentos, reembolsos, prêmios e o cumprimento das leis e autorizações necessárias.',
        },
      ],
    },
    {
      id: 'sua-conta',
      titulo: '3. Sua conta',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Você é responsável pelas informações que coloca e pela guarda da sua senha. Uma conta é pessoal. Podemos suspender contas usadas para fraude, para enganar outras pessoas ou em desacordo com estes termos.',
        },
      ],
    },
    {
      id: 'compras',
      titulo: '4. Compras e pagamentos',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Os pagamentos são processados pelo Mercado Pago. Antes de pagar, você vê o valor total, incluindo a taxa de serviço da plataforma, quando houver. A confirmação acontece quando o pagamento é aprovado. Cancelamentos e reembolsos seguem a política informada pelo organizador e a legislação aplicável, incluindo o Código de Defesa do Consumidor.',
        },
      ],
    },
    {
      id: 'ingressos',
      titulo: '5. Ingressos, fichas e QR codes',
      blocos: [
        {
          tipo: 'p',
          texto:
            'O QR code é a sua entrada ou a sua ficha. Não compartilhe com quem não deve usar: o primeiro uso vale. Fichas de barraca valem para o evento indicado.',
        },
      ],
    },
    {
      id: 'acoes-entre-amigos',
      titulo: '6. Ações entre amigos',
      blocos: [
        {
          tipo: 'p',
          texto:
            'São organizadas pela entidade responsável indicada na própria ação, que responde pela realização da ação, pela entrega dos prêmios e pelas autorizações exigidas. A plataforma oferece a ferramenta de venda e registro dos números.',
        },
      ],
    },
    {
      id: 'organizadores',
      titulo: '7. Organizadores',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Quem publica um evento declara ter autorização para organizá-lo, informa corretamente valores e condições, usa os dados dos participantes só para realizar o evento (conforme a Política de privacidade e a LGPD) e cuida do repasse e da prestação de contas à sua comunidade. As taxas da plataforma são informadas antes da publicação.',
        },
      ],
    },
    {
      id: 'nao-permitido',
      titulo: '8. O que não é permitido',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Publicar eventos falsos ou enganosos; usar a plataforma para fins ilegais; tentar acessar dados de outras pessoas ou de outros eventos; revender ingressos em desacordo com o organizador; usar conteúdos que ofendam a fé ou as pessoas.',
        },
      ],
    },
    {
      id: 'responsabilidade',
      titulo: '9. Responsabilidade',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Trabalhamos para a plataforma funcionar bem e com segurança, mas ela pode ter interrupções. Não respondemos pela realização dos eventos nem por atos dos organizadores, que são os responsáveis pelo que oferecem.',
        },
      ],
    },
    {
      id: 'mudancas-contato',
      titulo: '10. Mudanças e contato',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Podemos atualizar estes termos; a data no topo mostra a última atualização. Dúvidas: WhatsApp (14) 99640-2835 e trinda360@gmail.com. Fica eleito o foro da comarca de Tupã/SP para resolver questões destes termos, sem prejuízo dos direitos do consumidor.',
        },
      ],
    },
  ],
};